<template>
  <div id="app">
    <div class="container main-container">
      <div class="row pt-4">
        <div class="col-12">
          <h1><img src="./assets/img/logo.svg"></h1>
        </div>
        <div class="col-12">
          <nav class="navbar navbar-expand-lg justify-content-center">
            <ul class="nav navbar-nav pull-sm-left">
              <li class="nav-item">
                <router-link class="nav-link" to="/" >ESP</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/en">ENG</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/pt">POR</router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <router-view/>
    </div>
    <footer>
    </footer>
  </div>

</template>

<script>
  export default {
    name: 'App'
  }
</script>



// WEBPACK FOOTER //
// src/App.vue